import { AdministrationServicePath, STUDY_DEPARTMENT_INFO } from "utils/constants";
import permissions from "app/permissions";
import EditStudyDepartmentInfo from "./Edit";

//permissions
export const resources = {
  name: AdministrationServicePath + STUDY_DEPARTMENT_INFO,
  title: "Учебен отдел",
  edit: <EditStudyDepartmentInfo />,
  editPermission: permissions.canPreviewStudyDepartmentInfo,
};
